import { create } from 'zustand';

import type { Reservation } from '@/api';
// import { persist } from 'zustand/middleware';

interface CheckoutState {
  reservation: Reservation | null;
  stripeSecret: string;
  ephemeralKey: string;
  stripeCustomerId: string;
  setReservation: (reservation: Reservation) => void;
  setStripeSecret: (stripeSecret: string) => void;
  setEphemeralKey: (ephemeralKey: string) => void;
  setCustomerSessionSecret: (customerSessionSecret: string) => void;
  setStripeCustomerId: (stripeCustomerId: string) => void;
  reset: () => void;
}

const useCheckoutStore = create<CheckoutState>((set) => ({
  reservation: null,
  stripeSecret: '',
  ephemeralKey: '',
  customerSessionSecret: '',
  stripeCustomerId: '',
  setReservation: (reservation: Reservation) => {
    set((state) => ({
      ...state,
      reservation,
    }));
  },
  setStripeSecret: (stripeSecret: string) => {
    set((state) => ({
      ...state,
      stripeSecret,
    }));
  },
  setEphemeralKey: (ephemeralKey: string) => {
    set((state) => ({
      ...state,
      ephemeralKey,
    }));
  },
  setCustomerSessionSecret: (customerSessionSecret: string) => {
    set((state) => ({
      ...state,
      customerSessionSecret,
    }));
  },
  setStripeCustomerId: (stripeCustomerId: string) => {
    set((state) => ({
      ...state,
      stripeCustomerId,
    }));
  },
  reset: () => {
    set({
      reservation: null,
      stripeSecret: '',
      ephemeralKey: '',
      customerSessionSecret: '',
      stripeCustomerId: '',
    });
  },
}));

export default useCheckoutStore;

// export const useSearchStore = createSelectors(_useSearchStore);

// export const setAddress = (address: string) =>
//   _useSearchStore.getState().setAddress(address);
